// When passed the result of redux-actions' createActions function,
// returns an object with both keys and values set to the action types
// getActionTypes(createActions('SWAG')) results in { SWAG: 'SWAG' }

import { Action } from '../types/redux'

export const getActionTypes = (actions: { [x: string]: string | {} }): { [x: string]: string } => {
  const types: { [x: string]: string } = {}
  Object.keys(actions).forEach(name => {
    const type = actions[name].toString()
    types[type] = type
  })
  return types
}

export const prepareActions = (actionsNames: string[], prefix?: string): object => {
  const actions: any = {}

  actionsNames.map((actionName: string) => {
    let path = prefix || new Date().getTime().toString()
    path = path.toUpperCase()
    path = `${path}_${actionName}`

    const fnc = (payload: any): Action<any> => {
      const id = `${path}_${new Date().getTime().toString()}`

      const ret: any = {
        type: path,
        payload,
      }

      if (['modal_dialog', 'modal_loader', 'notification'].includes(prefix || '')) {
        ret.id = id
      }

      return ret
    }

    fnc.toString = () => path

    actions[actionName] = fnc
    return false
  })

  return actions
}
